import React from 'react';
import { FaStar, FaHeart, FaShoppingCart, FaHome } from 'react-icons/fa';
import ProductCard from '../components/ProductCard';
import { Helmet } from "react-helmet";

const products = [
  {
    id: 1,
    name: 'Ορός Προσώπου Πολυτελείας',
    shortDescription: 'Αντιγηραντικός ορός με φυσικά συστατικά',
    description: 'Ο πολυτελής ορός προσώπου μας περιέχει σπάνια φυτικά εκχυλίσματα που ανανεώνουν και αναζωογονούν το δέρμα σας. Κατάλληλος για όλους τους τύπους δέρματος.',
    price: 89.99,
    image: '/images/1.jpg',
    features: [
      'Φυσικά και βιολογικά συστατικά',
      'Κατάλληλο για όλους τους τύπους δέρματος',
      'Αντιγηραντικές ιδιότητες',
      'Βαθιά ενυδάτωση',
      'Χωρίς παραβένες και χημικά'
    ]
  },
  {
    id: 2,
    name: 'Κρέμα Νυχτός Premium',
    shortDescription: 'Εντατική αναδόμηση κατά τη διάρκεια του ύπνου',
    description: 'Η κρέμα νυχτός premium εργάζεται ενώ κοιμάστε για να σας χαρίσει λαμπερό και αναζωογονημένο δέρμα κάθε πρωί. Εμπλουτισμένη με βιταμίνες και αντιοξειδωτικά.',
    price: 75.50,
    image: '/images/2.jpg',
    features: [
      'Εντατική αναδόμηση νυχτερινή',
      'Βιταμίνες A, C, E',
      'Αντιοξειδωτική προστασία',
      'Μειώνει τις ρυτίδες',
      'Απαλή και μεταξένια υφή'
    ]
  },
  {
    id: 3,
    name: 'Μάσκα Ομορφιάς Χρυσού',
    shortDescription: 'Μάσκα με 24K χρυσό για άμεση λάμψη',
    description: 'Η μοναδική μας μάσκα ομορφιάς εμπλουτισμένη με 24K χρυσό προσφέρει άμεση λάμψη και σύσφιξη. Ιδανική για ειδικές περιστάσεις ή εβδομαδιαία περιποίηση.',
    price: 125.00,
    image: '/images/3.jpg',
    features: [
      'Περιέχει 24K χρυσό',
      'Άμεση λάμψη και lifting',
      'Σύσφιξη και τόνωση',
      'Πλούσια σε κολλαγόνο',
      'Αποτελέσματα από την πρώτη χρήση'
    ]
  },
  {
    id: 4,
    name: 'Ελιξίριο Ματιών',
    shortDescription: 'Εξαλείφει μαύρους κύκλους και οίδημα',
    description: 'Το εξειδικευμένο ελιξίριο για την περιοχή των ματιών μειώνει την κούραση, τους μαύρους κύκλους και το οίδημα. Απαλή φόρμουλα για ευαίσθητο δέρμα.',
    price: 65.00,
    image: '/images/4.jpg',
    features: [
      'Μειώνει μαύρους κύκλους',
      'Αποσυμφορεί το οίδημα',
      'Ενυδατώνει την ευαίσθητη περιοχή',
      'Αντιγηραντική δράση',
      'Ελαφριά υφή που απορροφάται γρήγορα'
    ]
  },
  {
    id: 5,
    name: 'Πακέτο Περιποίησης Deluxe',
    shortDescription: 'Πλήρης ρουτίνα περιποίησης πολυτελείας',
    description: 'Το πλήρες σετ περιποίησης που περιλαμβάνει όλα τα απαραίτητα προϊόντα για μια ολοκληρωμένη ρουτίνα ομορφιάς. Ιδανικό για δώρο ή για να ξεκινήσετε το ταξίδι σας προς την τέλεια επιδερμίδα.',
    price: 299.99,
    image: '/images/5.jpg',
    features: [
      'Πλήρες σετ περιποίησης',
      'Όλα τα απαραίτητα προϊόντα',
      'Οικονομική πρόταση',
      'Πολυτελής συσκευασία δώρου',
      'Οδηγίες χρήσης step-by-step'
    ]
  }
];

function Home() {
  return (
    <>
      <Helmet>
        <title>Sororin - Κατάστημα Ομορφιάς με προϊόντα υψηλής ποιότητας</title>
        <meta name="description" content="Sororin - Κατάστημα Ομορφιάς με προϊόντα υψηλής ποιότητας. Ανακαλύψτε την πολυτελή συλλογή μας από προϊόντα περιποίησης και ομορφιάς." />
      </Helmet>

      <div className="home-container">
      <section className="hero-section">
        <div className="hero-content">
          <h1>Καλώς ήρθατε στο Sororin</h1>
          <p className="hero-tagline">Όπου η ομορφιά συναντά την πολυτέλεια</p>
          <p>
            Ανακαλύψτε την αποκλειστική μας συλλογή προϊόντων ομορφιάς που θα μεταμορφώσουν 
            τη ρουτίνα περιποίησής σας. Κάθε προϊόν επιλέγεται με προσοχή για να σας προσφέρει 
            την απόλυτη εμπειρία πολυτέλειας και αποτελεσματικότητας.
          </p>
        </div>
      </section>

      <section className="advantages-section">
        <div className="advantages-header">
          <h2>Γιατί να Επιλέξετε τα Προϊόντα μας</h2>
          <p>
            Στο Sororin, δεσμευόμαστε να σας προσφέρουμε μόνο τα καλύτερα προϊόντα ομορφιάς 
            που συνδυάζουν την παράδοση με την καινοτομία.
          </p>
        </div>

        <div className="advantages-grid">
          <div className="advantage-card">
            <FaStar className="advantage-icon" />
            <h3>Εξαιρετική Ποιότητα</h3>
            <p>
              Όλα τα προϊόντα μας υποβάλλονται σε αυστηρούς ελέγχους ποιότητας και 
              περιέχουν μόνο τα καλύτερα φυσικά συστατικά από όλο τον κόσμο.
            </p>
          </div>

          <div className="advantage-card">
            <FaHeart className="advantage-icon" />
            <h3>Φυσικά Συστατικά</h3>
            <p>
              Χρησιμοποιούμε αποκλειστικά βιολογικά και φυσικά συστατικά που είναι ασφαλή 
              για το δέρμα σας και το περιβάλλον. Χωρίς χημικά και παραβένες.
            </p>
          </div>

          <div className="advantage-card">
            <FaShoppingCart className="advantage-icon" />
            <h3>Πιστοποιημένα Προϊόντα</h3>
            <p>
              Κάθε προϊόν διαθέτει διεθνείς πιστοποιήσεις ποιότητας και ασφάλειας. 
              Δερματολογικά δοκιμασμένα και εγκεκριμένα από ειδικούς.
            </p>
          </div>

          <div className="advantage-card">
            <FaHome className="advantage-icon" />
            <h3>Εγγύηση Ικανοποίησης</h3>
            <p>
              Προσφέρουμε πλήρη εγγύηση ικανοποίησης για όλα τα προϊόντα μας. 
              Αν δεν είστε ευχαριστημένοι, επιστρέφουμε τα χρήματά σας χωρίς ερωτήσεις.
            </p>
          </div>
        </div>

        <div className="stats-container">
          <div className="stat-item">
            <span className="stat-number">15000+</span>
            <span className="stat-label">Ευχαριστημένοι Πελάτες</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">12</span>
            <span className="stat-label">Χρόνια Εμπειρίας</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">98%</span>
            <span className="stat-label">Θετικές Κριτικές</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">50+</span>
            <span className="stat-label">Μοναδικά Προϊόντα</span>
          </div>
        </div>

        <div className="cta-section">
          <p style={{ fontSize: '1.2rem', marginBottom: '1.5rem', color: 'var(--text-light)' }}>
            Ξεκινήστε το ταξίδι σας προς την τέλεια επιδερμίδα σήμερα
          </p>
          <a href="#products" className="cta-button">Εξερευνήστε τη Συλλογή μας</a>
        </div>
      </section>

      <section className="detailed-info-section">
        <h2>Η Φιλοσοφία μας για την Ομορφιά</h2>
        
        <div className="info-content">
          <p className="info-paragraph">
            Στο Sororin, πιστεύουμε ότι η αληθινή ομορφιά προέρχεται από τη φροντίδα και την αγάπη 
            που δείχνουμε στον εαυτό μας. Γι αυτό το λόγο, δημιουργούμε προϊόντα που όχι μόνο 
            βελτιώνουν την εμφάνιση του δέρματός σας, αλλά και τρέφουν την ψυχή σας. Κάθε προϊόν 
            είναι το αποτέλεσμα χρόνων έρευνας, δοκιμών και αφοσίωσης στην τελειότητα.
          </p>

          <p className="info-paragraph">
            Η συλλογή μας αποτελείται από προϊόντα που συνδυάζουν αρχαίες συνταγές ομορφιάς με 
            σύγχρονη επιστημονική τεχνολογία. Χρησιμοποιούμε σπάνια βότανα από την Ελλάδα, φυσικά 
            έλαια από την Μεσόγειο και καινοτόμα συστατικά που έχουν αποδειχθεί κλινικά. Το αποτέλεσμα 
            είναι προϊόντα που όχι μόνο λειτουργούν, αλλά προσφέρουν και μια πολυτελή εμπειρία 
            περιποίησης που μεταμορφώνει την καθημερινή σας ρουτίνα σε τελετουργικό χαλάρωσης.
          </p>

          <p className="info-paragraph">
            Όλα τα προϊόντα μας παράγονται σε μικρές παρτίδες για να διασφαλίσουμε τη μέγιστη φρεσκάδα 
            και αποτελεσματικότητα. Δεν κάνουμε συμβιβασμούς όσον αφορά την ποιότητα. Κάθε συστατικό 
            επιλέγεται προσεκτικά και προέρχεται από πιστοποιημένους προμηθευτές που μοιράζονται τις 
            αξίες μας για τη βιωσιμότητα και την κοινωνική ευθύνη. Είμαστε υπερήφανοι που δημιουργούμε 
            προϊόντα που είναι καλά όχι μόνο για εσάς, αλλά και για τον πλανήτη.
          </p>
        </div>

        <div className="info-highlights">
          <div className="highlight-item">
            <h3>Διεθνείς Πιστοποιήσεις</h3>
            <p>
              Πιστοποιημένα από τους κορυφαίους διεθνείς οργανισμούς ποιότητας και ασφάλειας 
              καλλυντικών προϊόντων.
            </p>
          </div>
          <div className="highlight-item">
            <h3>Δερματολογικά Δοκιμασμένα</h3>
            <p>
              Όλα τα προϊόντα έχουν δοκιμαστεί από πιστοποιημένους δερματολόγους και είναι 
              ασφαλή για όλους τους τύπους δέρματος.
            </p>
          </div>
          <div className="highlight-item">
            <h3>Βιώσιμη Παραγωγή</h3>
            <p>
              Δεσμευόμαστε για την προστασία του περιβάλλοντος με οικολογικές συσκευασίες 
              και βιώσιμες πρακτικές παραγωγής.
            </p>
          </div>
          <div className="highlight-item">
            <h3>Cruelty-Free</h3>
            <p>
              Κανένα από τα προϊόντα μας δεν δοκιμάζεται σε ζώα. Πιστοποιημένα vegan και 
              φιλικά προς τα ζώα.
            </p>
          </div>
        </div>
      </section>

      <section className="expert-interview">
        <div className="interview-header">
          <h2>Συνέντευξη με Ειδικό</h2>
          <p className="expert-name">Δρ. Ελένη Παπαδοπούλου</p>
          <p className="expert-title">Δερματολόγος - Ειδικός σε Αισθητική Ιατρική</p>
        </div>

        <div className="interview-content">
          <div className="interview-question">
            <strong>Ερώτηση: Τι κάνει τα προϊόντα Sororin ξεχωριστά από άλλα στην αγορά;</strong>
            <p>
              Τα προϊόντα Sororin ξεχωρίζουν για τον μοναδικό συνδυασμό φυσικών συστατικών υψηλής 
              ποιότητας με επιστημονικά αποδεδειγμένες φόρμουλες. Ως δερματολόγος, εκτιμώ ιδιαίτερα 
              το γεγονός ότι κάθε προϊόν έχει δοκιμαστεί κλινικά και είναι απολύτως ασφαλές για 
              μακροχρόνια χρήση. Η απουσία επιβλαβών χημικών ουσιών τα καθιστά ιδανικά ακόμα και 
              για τα πιο ευαίσθητα δέρματα.
            </p>
          </div>

          <div className="interview-question">
            <strong>Ερώτηση: Ποια προϊόντα θα συνιστούσατε για καθημερινή χρήση;</strong>
            <p>
              Για καθημερινή ρουτίνα, συνιστώ ανεπιφύλακτα τον Ορό Προσώπου Πολυτελείας το πρωί 
              και την Κρέμα Νυχτός Premium το βράδυ. Αυτός ο συνδυασμός παρέχει ολοκληρωμένη 
              προστασία και αναδόμηση καθ όλη τη διάρκεια του 24ώρου. Για ειδικές περιστάσεις, 
              η Μάσκα Ομορφιάς Χρυσού προσφέρει άμεσα ορατά αποτελέσματα που διαρκούν.
            </p>
          </div>

          <div className="interview-question">
            <strong>Ερώτηση: Πόσο καιρό χρειάζεται για να δούμε αποτελέσματα;</strong>
            <p>
              Τα περισσότερα άτομα παρατηρούν βελτίωση στην υφή και την ενυδάτωση του δέρματος 
              εντός της πρώτης εβδομάδας χρήσης. Για πιο σημαντικές αλλαγές, όπως η μείωση των 
              ρυτίδων και η βελτίωση της ελαστικότητας, συνιστώ συνεχή χρήση για τουλάχιστον 
              4-6 εβδομάδες. Τα αποτελέσματα είναι σταδιακά αλλά μόνιμα με την κανονική χρήση.
            </p>
          </div>
        </div>
      </section>

      <section id="products" className="products-section">
        <h2 className="section-title">Η Συλλογή μας</h2>
        <div className="products-grid">
          {products.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </section>
    </div>
  
    </>);
}

export default Home;